import { render, staticRenderFns } from "./loaderWrapper.vue?vue&type=template&id=df6a9140&scoped=true&lang=html&"
import script from "./loaderWrapper.vue?vue&type=script&lang=js&"
export * from "./loaderWrapper.vue?vue&type=script&lang=js&"
import style0 from "./loaderWrapper.vue?vue&type=style&index=0&id=df6a9140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6a9140",
  null
  
)

export default component.exports